import { BrowserRouter as Router } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { ThemeProvider, CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { SnackbarProvider } from 'notistack';

import theme from 'assets';
import 'assets/sites_cookiebot.css';

import { Routes } from 'components';

import 'react-quill/dist/quill.snow.css'; // ES6
import 'helpers/Extensions';

import { AxiosInterceptors, ApplicationUserProvider, AuthenticationProvider } from 'helpers/services';

moment.locale('en', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd D MMMM YYYY HH:mm'
  }
});


let App = () => {
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <SnackbarProvider preventDuplicate>
          <CssBaseline />
          <Router>
            <AuthenticationProvider>
              <AxiosInterceptors />
              <ApplicationUserProvider>
                <Routes />
              </ApplicationUserProvider>
            </AuthenticationProvider>
          </Router>
        </SnackbarProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}

export default App;